// extracted by mini-css-extract-plugin
export var file = "file-module--file--3qBW0";
export var fileImage = "file-module--fileImage--1TXc_";